module.exports = __webpack_public_path__ + "static/media/edison.13ecc808.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/edison.png
// module id = 270
// module chunks = 0